function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Component } from 'react';
import { View, Text, StyleSheet } from 'react-native';
export class Cell extends Component {
  render() {
    const {
      data,
      width,
      height,
      flex,
      style,
      textStyle,
      borderStyle,
      ...props
    } = this.props;
    const textDom = /*#__PURE__*/React.isValidElement(data) ? data : /*#__PURE__*/React.createElement(Text, _extends({
      style: [textStyle, styles.text]
    }, props), data);
    const borderTopWidth = borderStyle && borderStyle.borderWidth || 0;
    const borderRightWidth = borderTopWidth;
    const borderColor = borderStyle && borderStyle.borderColor || '#000';
    const widthStyle = width ? {
      width
    } : {};
    const heightStyle = height ? {
      height
    } : {};
    let flexStyle = flex ? {
      flex
    } : {};

    if (width && !flex && !height && !style) {
      flexStyle = {
        flex: 1
      };
    }

    return /*#__PURE__*/React.createElement(View, {
      style: [{
        borderTopWidth,
        borderRightWidth,
        borderColor
      }, styles.cell, widthStyle, heightStyle, flexStyle, style]
    }, textDom);
  }

}
const styles = StyleSheet.create({
  cell: {
    justifyContent: 'center'
  },
  text: {
    backgroundColor: 'transparent'
  }
});
//# sourceMappingURL=cell.js.map